import { useMemo } from 'react';
import { Track } from 'livekit-client';
import { type TrackReference, useLocalParticipant } from '@livekit/components-react';

/**
 * Get a track reference for a local participant's track.
 * 
 * @param source - The track source (Microphone, Camera, ScreenShare, etc.)
 * @returns TrackReference or undefined if track is not published
 */
export function useLocalTrackRef(source: Track.Source) {
    const { localParticipant } = useLocalParticipant();
    const publication = localParticipant.getTrackPublication(source);
    const trackRef = useMemo<TrackReference | undefined>(
        () => (publication ? { source, participant: localParticipant, publication } : undefined),
        [source, publication, localParticipant]
    );
    return trackRef;
}
